import { createContext, ReactNode, useContext, useState } from "react";
import CompanyService from "../../../../services/CompanyService";

type ActivityView = "detallada" | "compacta";

const getStorageKey = () =>
  `intiza_activity_view_${CompanyService.getUserid()}`;

const ActivityViewContext = createContext<{
  view: ActivityView;
  setView: (v: ActivityView) => void;
}>({
  view: "detallada",
  setView: () => {}
});

export const ActivityViewProvider = ({ children }: { children: ReactNode }) => {
  const [view, setViewState] = useState<ActivityView>(() => {
    try {
      return localStorage.getItem(getStorageKey()) === "compacta"
        ? "compacta"
        : "detallada";
    } catch {
      return "detallada";
    }
  });

  const setView = (v: ActivityView) => {
    setViewState(v);
    try {
      localStorage.setItem(getStorageKey(), v);
    } catch {}
  };

  return (
    <ActivityViewContext.Provider value={{ view, setView }}>
      {children}
    </ActivityViewContext.Provider>
  );
};

export const useActivityView = () => useContext(ActivityViewContext);
